import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
/**
 * 表单控件内容
 * @private
 */
var FormControlContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 8px;\n\n  & > .sinoui-checkbox-group,\n  & > .sinoui-radio-group {\n    margin-top: 4px;\n    margin-bottom: 6px;\n  }\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 8px;\n\n  & > .sinoui-checkbox-group,\n  & > .sinoui-radio-group {\n    margin-top: 4px;\n    margin-bottom: 6px;\n  }\n"])));
export default FormControlContent;
var templateObject_1;
//# sourceMappingURL=FormControlContent.js.map